import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";
import { Cookies } from "react-cookie";

export const addPresident = createAsyncThunk("addPresident", async (data) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const response = await AxiosInstance.post(`${API_KEY}/api/president/add`, data, {
      headers: { Authorization: `Barear ${token}`},
      "Content-Type": "application/json",
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  addPresidentData: null,
  isError: false,
  errorMessage: "",
};
const addPresidentSlice = createSlice({
  name: "addPresident",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(addPresident.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addPresident.fulfilled, (state, action) => {
      state.isLoading = false;
      state.addPresidentData = action.payload;
    });
    builder.addCase(addPresident.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default addPresidentSlice.reducer;